module.exports = __webpack_public_path__ + "img/inkie2.81e95584.gif";